/**
 * @desc 实现useEnhance 未验证
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Toast } from 'antd-mobile'
import BaseUbt from '../../base/BaseUbt'
import { HEADER_HEIGHT } from '../constant'
import { UtilCommon, UtilEmitter, UtilDevice, Bridge } from '@iskytrip/sdk'

/**
 * @description 是否获取了过信号栏高度
 */
let _isGetSignalBarHeight = false

/**
 * @description 存储信号栏高度
 */
let signalBarHeight = 0

const Enhance = (WrappedComponent) => {
	class Enhance extends WrappedComponent {
		static propTypes = {
			className: PropTypes.string,
			style: PropTypes.object,
		}

		static defaultProps = {
			className: '',
			style: {},
		}

		constructor(props) {
			super(props)
			this.state = {
				...(this.state || {}),
				_info: null,
				_error: false, //捕获错误信息
			}

			this.signalBarHeightListener = UtilEmitter.addListener(
				'signalBarHeight',
				(_signalBarHeight) => {
					setTimeout(() => {
						this.getSignalBarHeight && this.getSignalBarHeight(_signalBarHeight)
						this.getWholeNavBarHeight &&
							this.getWholeNavBarHeight(_signalBarHeight + HEADER_HEIGHT)
					}, 0)
					UtilEmitter.removeListener(this.signalBarHeightListener)
				},
			)

			this._getSignalBarHeight()
		}

		/** life cycle start */
		componentDidCatch(error, info) {
			console.error('componentDidCatch', error, info)
			this.setState({ _error: error, _info: info })
			super.componentDidCatch && super.componentDidCatch(error, info)
		}

		render() {
			if (this.state._error) {
				return (
					<>
						<h1>Error: {this.state._error.toString()}</h1>
						<h1>Error: {this.state._info.toString()}</h1>
					</>
				)
			} else {
				return super.render && super.render()
			}
		}
		/** life cycle end */

		/** custom func start */
		_query = UtilCommon._query

		go = UtilCommon.go

		redirect = (...arg) => {
			this.props.history.replace(...arg)
		}

		jump = UtilCommon.jump

		back = UtilCommon.back

		trans = UtilCommon.trans

		goLogin = UtilCommon.goLogin

		urlQuery = UtilCommon.urlQuery

		commonGoURL = UtilCommon.commonGoURL

		setWindowTitle = UtilCommon.setWindowTitle

		trancePv = BaseUbt.pv.bind(BaseUbt)

		tranceEvent = BaseUbt.event.bind(BaseUbt)

		tranceLog = BaseUbt.traceLog.bind(BaseUbt)

		/**
		 * @description 获取导航栏高度
		 * @returns {int}
		 * @memberof BasePage
		 */
		getNavBarHeight() {
			return HEADER_HEIGHT
		}

		share(...args) {
			UtilCommon.share(...args)
			if (!UtilDevice.isApp()) {
				return Toast.info('当前环境不支持分享，请至App分享', 1.5)
			}
		}
		/** custom func end */

		/**
		 * @description 获取页面信号栏高度
		 * @memberof BasePage
		 */
		async _getSignalBarHeight() {
			if (UtilDevice.isApp()) {
				if (!_isGetSignalBarHeight) {
					_isGetSignalBarHeight = true
					signalBarHeight = await this._appGetSignalBarHeight()
					UtilEmitter.emit('signalBarHeight', signalBarHeight)
				} else {
					if (signalBarHeight) UtilEmitter.emit('signalBarHeight', signalBarHeight)
				}
			} else {
				UtilEmitter.emit('signalBarHeight', signalBarHeight)
			}
		}

		_appGetSignalBarHeight() {
			return new Promise((resolve) => {
				if (UtilCommon._query.signalBarHeight) {
					resolve(+UtilCommon._query.signalBarHeight)
				} else {
					Bridge.appGetSignalBarHeight((height) => {
						resolve(height)
					})
				}
			})
		}
	}

	Enhance.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Enhance'
	return Enhance
}

export default Enhance
